import Vue from "vue";
import Vuex, {StoreOptions} from "vuex";
import {Mutation} from "@/store/mutation-types";
import {RootState} from "@/store/types";
import {Action} from "@/store/action-types";
import {Howl} from "howler";
import {InteractableElement, SoundString} from "@/types";

Vue.use(Vuex);

const isMobileDevice = (): boolean => (
  navigator.maxTouchPoints
    ? !!(navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i)) && (navigator.maxTouchPoints > 0)
    : !!(navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i))
)

const getOrientation = () => {
  if (window.matchMedia('(orientation: portrait)').matches) return 'portrait';
  return 'landscape';
}


const store: StoreOptions<RootState> = {
  state: {
    isMobile: isMobileDevice(),
    orientation: getOrientation(),
    vWidth: 0,
    vHeight: 0,
    sounds: [],
  },
  mutations: {
    [Mutation.GET_VIEWPORT_DIMENSIONS] (state) {
      state.orientation = window.matchMedia('(orientation: portrait)').matches ? 'portrait' : 'landscape'
      state.vWidth = parseInt(document.getElementsByTagName('html')[0].getBoundingClientRect().width.toString())
      state.vHeight = document.documentElement.clientHeight
    },
    [Mutation.FETCH_SOUNDS] (state, sounds) {
      state.sounds = sounds;
    }
  },
  actions: {
    [Action.FETCH_SOUNDS] ({ commit }) {
      const sounds: SoundString[] = [
        "car",
        "church",
        "bicycle",
        "dam",
        "trio",
        "square",
        "reservoir",
        "mountains",
      ];
      const fetchedSoundsArr: any = {};
      sounds.forEach((sound) => {
        const el = require(`@/assets/sounds/${sound}.ogg`);
        fetchedSoundsArr[sound] = new Howl({
          src: el,
          loop: true,
          volume: 0.5,
        })
      });

      commit(Mutation.FETCH_SOUNDS, fetchedSoundsArr)
    }
  },
  modules: {}
};

export default new Vuex.Store<RootState>(store);
